export default __webpack_public_path__ + "static/media/Kristina Bondar.9fcdd1b4.jpg";